import moment from "moment/moment"

export function dateParse(date) {
    let data = moment(date).format('yyyy-MM-DD')
    if (data !== 'Invalid date' && date !== null) {
        return data
    } else {
        return ''
    }
}

export function dateTimeParse(date) {
    let data = moment(date).format('yyyy-MM-DD HH:mm:ss')
    if (data !== 'Invalid date' && date !== null) {
        return data
    } else {
        return ''
    }
}
export function timeParse(time) {
    let data = moment(time).format('HH:mm')
    if (data !== 'Invalid date' && time !== null) {
        return data
    } else {
        return ''
    }
}
export function padLeadingZeros(num, size) {
    var s = num + ''
    while (s.length < size) s = '0' + s
    return s
}

export function yearParse(date) {
    return moment(date).format('yyyy')
}
export function yearMonthParse(date) {

    return moment(date).format('yyyy-MM');
}

export function roundDecimal(value, precision) {
    var multiplier = Math.pow(10, precision || 0)
    return Math.round(value * multiplier) / multiplier
}

export function convertTocommaSeparated(value, precision, minimumFractionDigits = 2) {
    if (precision === 0) {
        return (parseFloat(value).toLocaleString('en-US', { style: 'decimal' }))
    } else {
        return (parseFloat(roundDecimal(value, precision)).toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: minimumFractionDigits }))
    }
}


export function convertTocommaSeparatedWithoutRound(value) {
    const parts = parseFloat(value).toString().split('.');
    let lengthOFDecimal = parts.length > 1 ? parts[1].length : 0;
    return (parseFloat(value).toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: lengthOFDecimal }));
}


export function convertTocommaSeparatedWithoutDecimal(value, precision, minimumFractionDigits = 2) {
    if (value === null) {
        return null
    } else if (precision === 0) {
        return (parseInt(value).toLocaleString('en-US', { style: 'decimal' }))
    } else {
        return (Math.round(roundDecimal(value, precision)).toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: minimumFractionDigits }))
    }
}

export function scrollToTop() {
    // Scroll the entire page to the top
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
}

export function includesArrayElements(arr1, arr2) {
    return arr2.some(element => arr1.includes(element));
}

export function isValidJsonString(str) {
    if (typeof str !== 'string') return false;
    try {
        JSON.parse(str);
        return true;
    } catch (e) {
        return false;
    }
}

export function getRatingColor(rating) {
    if (rating <= 5) {
        return "green";  // Very Low to Low
    } else if (rating < 10) {
        return "yellow";  // Medium
    } else if (rating <= 15) {
        return "orange";  // High to Very High
    } else {
        return "red";  // Extreme
    }
}

/**
 * Parse Sri Lankan NIC number and extract birth date, age, and gender
 * Supports both old format (9 digits + V/X) and new format (12 digits)
 * @param {string} nic - The NIC number to parse
 * @returns {object} - Object containing birthDate, age, and gender
 */
export function parseNIC(nic) {
    if (!nic || typeof nic !== 'string') {
        return { birthDate: null, age: null, gender: null, isValid: false };
    }

    // Remove spaces and convert to uppercase
    const cleanNic = nic.trim().toUpperCase();

    // Validate NIC format
    const oldFormatRegex = /^\d{9}[VX]$/;  // 9 digits + V or X
    const newFormatRegex = /^\d{12}$/;     // 12 digits

    let year, dayOfYear, gender;

    if (oldFormatRegex.test(cleanNic)) {
        // Old format: 9 digits + V/X
        const yearDigits = cleanNic.substring(0, 2);
        const dayOfYearStr = cleanNic.substring(2, 5);
        const lastChar = cleanNic.substring(9, 10);

        // Determine full year
        year = parseInt(yearDigits);
        if (lastChar === 'V') {
            year += (year <= 25) ? 2000 : 1900; // Assume cutoff at 2025
        } else if (lastChar === 'X') {
            year += 1900;
        }

        dayOfYear = parseInt(dayOfYearStr);

    } else if (newFormatRegex.test(cleanNic)) {
        // New format: 12 digits
        year = parseInt(cleanNic.substring(0, 4));
        dayOfYear = parseInt(cleanNic.substring(4, 7));

    } else {
        return { birthDate: null, age: null, gender: null, isValid: false };
    }

    // Determine gender and actual day of year
    if (dayOfYear > 500) {
        gender = 'Female';
        dayOfYear -= 500;
    } else {
        gender = 'Male';
    }

    // Validate day of year (1-366)
    if (dayOfYear < 1 || dayOfYear > 366) {
        return { birthDate: null, age: null, gender: null, isValid: false };
    }

    // Calculate birth date
    try {
        const birthDate = new Date(year, 0, dayOfYear); // January 1st + (dayOfYear - 1)

        // Validate the calculated date
        if (isNaN(birthDate.getTime())) {
            return { birthDate: null, age: null, gender: null, isValid: false };
        }

        // Calculate age
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        // Validate reasonable age range
        if (age < 0 || age > 120) {
            return { birthDate: null, age: null, gender: null, isValid: false };
        }

        return {
            birthDate: birthDate,
            age: age.toString(),
            gender: gender,
            isValid: true
        };

    } catch (error) {
        return { birthDate: null, age: null, gender: null, isValid: false };
    }
}